export default "__VITE_ASSET__VhkyKZpo__"